// California Zip Code Ranges and Validation
// California zip codes range from 90001 to 96162

// California zip code ranges by region
export const CA_ZIP_RANGES = [
  { min: 90001, max: 90899, region: 'Los Angeles' },
  { min: 91000, max: 91899, region: 'Los Angeles/Pasadena' },
  { min: 92000, max: 92899, region: 'San Diego/Orange County' },
  { min: 93000, max: 93999, region: 'Central California' },
  { min: 94000, max: 94999, region: 'Bay Area/San Francisco' },
  { min: 95000, max: 95999, region: 'San Jose/Sacramento' },
  { min: 96000, max: 96162, region: 'Northern California' }
];

// Validate if a zip code is a valid California zip code
export function isValidCaliforniaZipCode(zipCode) {
  if (!zipCode) return false;
  
  // Must be exactly 5 digits
  if (!/^\d{5}$/.test(zipCode)) return false;
  
  const zip = parseInt(zipCode, 10);
  
  // Check if zip is in any valid California range
  return CA_ZIP_RANGES.some(range => zip >= range.min && zip <= range.max);
}

// Get approximate region for a zip code
export function getZipCodeRegion(zipCode) {
  if (!isValidCaliforniaZipCode(zipCode)) return null;
  
  const zip = parseInt(zipCode, 10);
  const range = CA_ZIP_RANGES.find(r => zip >= r.min && zip <= r.max);
  return range ? range.region : null;
}

// Format zip code display (ensure 5 digits with leading zeros)
export function formatZipCode(zipCode) {
  if (!zipCode) return '';
  return String(zipCode).padStart(5, '0');
}
